// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mpGo","toggleWrap":"styles_toggleWrap__CV-fB","content":"styles_content__1D7re","selectAreaCode":"styles_selectAreaCode__2oxoI"};